import {
  addSignCommaFormat,
  commaFormat,
} from 'components/features/new-report/utils/formatter';
import React from 'react';
import { Percentage } from '../../../share/Percentage';

export const RemainAmount = ({
  currentAmount,
  targetAmount,
  limit,
  className,
}: {
  currentAmount: number;
  targetAmount: number;
  limit:
    | {
        period: 'year' | 'month';
        value: number;
      }
    | {
        period: 'alltime';
      };
  className?: string;
}): React.ReactElement => {
  const num = (currentAmount / targetAmount) * 100;
  const percentage = Number.isNaN(num) ? 0 : num;
  const isAchieved = currentAmount >= targetAmount || targetAmount === 0;
  return (
    <>
      <div className={`flex flex-col px-8 ${className ?? ''}`}>
        {isAchieved && (
          <div className="z-0 relative flex flex-row mt-2">
            <div
              className={`py-1 px-3 mb-2 bg-white border border-bluegray-300 relative ml-auto rounded`}>
              <div
                className="border-b border-r border-bluegray-300 bg-white w-2 h-2 absolute"
                style={{
                  transform: 'rotate(45deg)',
                  right: '3rem',
                  top: '1.25rem',
                  zIndex: 10,
                }}></div>
              <div className="z-20 rounded bg-white absolute right-0 top-0 left-0 bottom-0"></div>
              <div
                className={`flex flex-row items-center text-gray-700 text-xs font-bold h-4 z-30`}>
                <div className={`z-20`}>お疲れ様でした！</div>
              </div>
            </div>
          </div>
        )}
        <div className={`flex flex-row items-baseline`}>
          <div className={`mr-auto font-bold text-sm`}>
            {((): string => {
              switch (limit.period) {
                case 'month':
                  return '今月';
                case 'year':
                  return '今年';
                case 'alltime':
                  return '全体';
              }
            })()}
            の実績
          </div>
          {isAchieved ? (
            <div className={`text-orange-asset text-xl font-bold`}>達成</div>
          ) : (
            <>
              <div className={`text-teal-500 font-bold text-2xl mr-1`}>
                {commaFormat(currentAmount, { numberOfDecimals: 0 })}
              </div>
              <div className={`text-teal-500 text-xs`}>円</div>
            </>
          )}
        </div>
        <div className={`mt-1`}>
          <Percentage
            {...{
              percentage: Math.floor(percentage),
              backgroundColorTailwind: 'bg-gray-300',
              foregroundColorTailwind: isAchieved ? null : 'bg-blue-500',
              isShowPercentageStr: true,
              isAchieved: isAchieved,
              classNames: {
                percentageStr: prev =>
                  prev
                    .split(' ')
                    .map(s => (/^font-bold$/.test(s) ? 'font-normal' : s))
                    .join(' '),
              },
            }}
          />
        </div>
        <div
          className={`mt-3 flex flex-row items-baseline ml-auto text-bluegray-700`}>
          <div className={`mr-2 text-xs`}>
            {((): string => {
              switch (limit.period) {
                case 'month':
                  return '今月';
                case 'year':
                  return '今年';
                case 'alltime':
                  return '全体';
              }
            })()}
            の目標金額
          </div>
          <div className={`mr-1 text-lg`}>
            {limit.period === 'alltime'
              ? commaFormat(targetAmount, { numberOfDecimals: 0 })
              : addSignCommaFormat(targetAmount, { numberOfDecimals: 0 })}
          </div>
          <div className={`text-base`}>円</div>
        </div>
      </div>
    </>
  );
};
